import { useState, useEffect } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { BadgeCheck, RefreshCw, AlertTriangle } from "lucide-react";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-FR", { timeZone: "Europe/Paris", day: "numeric", month: "long", year: "numeric" }) : "");

export const MemberStatus = ({ u, onChanged }) => {
  const [busy, setBusy] = useState(false);
  if (u.role === "admin") return <span className="text-xs text-slate-400" data-testid={`member-status-${u.id}`}>Hors contrôle (administrateur)</span>;
  const m = u.membre_apollo;
  const check = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/users/${u.id}/verifier-membre`);
      toast.success(data.membre ? "Membre APOLLO reconnu" : "Non reconnu comme membre APOLLO");
      onChanged?.({ ...u, membre_apollo: data.membre_apollo, plan: data.plan });
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    setBusy(false);
  };
  return (
    <div className="space-y-1" data-testid={`member-status-${u.id}`}>
      {!u.email_verified ? <p className="text-xs text-slate-500">Adresse pas encore confirmée</p>
        : m?.statut === "reconnu" ? <p className="text-xs font-semibold text-emerald-700 flex items-center gap-1"><BadgeCheck className="h-3.5 w-3.5" /> Membre APOLLO vérifié le {fmt(m.verifie_le)}</p>
        : m?.statut === "non_reconnu" ? <p className="text-xs font-semibold text-slate-600">Non reconnu <span className="font-normal text-slate-400">(le {fmt(m.verifie_le)})</span></p>
        : <p className="text-xs text-slate-400">Pas encore vérifié</p>}
      {u.email_verified && <button onClick={check} disabled={busy} data-testid={`member-verify-${u.id}`} className="inline-flex items-center gap-1 text-xs font-semibold text-coral-dark hover:underline disabled:opacity-50"><RefreshCw className={`h-3 w-3 ${busy ? "animate-spin" : ""}`} /> Vérifier maintenant</button>}
    </div>
  );
};

export const MemberCheckAlert = () => {
  const [st, setSt] = useState(null);
  useEffect(() => { api.get("/admin/membres/controle").then((r) => setSt(r.data)).catch(() => {}); }, []);
  if (!st || st.nuits_en_echec < 2) return null;
  return (
    <div role="alert" className="mb-6 border border-red-200 bg-red-50 text-red-800 rounded-sm p-4 text-sm inline-flex items-start gap-2" data-testid="member-check-alert">
      <AlertTriangle className="h-4 w-4 mt-0.5 shrink-0" />
      <span>Le contrôle nocturne des membres APOLLO échoue depuis {st.nuits_en_echec} nuits : le service de vérification ne répond pas. Aucun accès n'a été retiré.</span>
    </div>
  );
};
